module.exports = __webpack_public_path__ + "media/images/logo_sm-d53985e53f07f086b6bab532190c0503.png";